import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-HmacAuth',
    templateUrl: './HmacAuth.component.html'
})
export class HmacAuthComponent implements OnInit {

    consumerID: string;
    hide_credentials = false;
    clock_skew = 300;
    anonymous: string;
    enforce_headers: [];
    algorithms: string;
    validate_request_body = false;

    data = {
        'consumerID' : this.consumerID,
        'hide_credentials' : this.hide_credentials,
        'clock_skew' : this.clock_skew,
        'anonymous' : this.anonymous,
        'enforce_headers' : this.enforce_headers,
        'algorithms' : this.algorithms,
        'validate_request_body' : this.validate_request_body,
        'plugin': 'hmac-auth'
    }

    constructor() { }

    slider() {
        this.hide_credentials = !this.hide_credentials;
    }

    slider1() {
        this.validate_request_body = !this.validate_request_body;
    }

    HmacAuth() {
    }

    ngOnInit() {
    }

}
